module.exports = __webpack_public_path__ + "img/station-off.ec60ffdb.png";